import React, { FC, useCallback, useMemo } from 'react';

import {
	EvSection,
	TABLE_FILTERS_SR_SUMMARY,
	TEvFiltersPanelValues
} from '@evinced-private/ui-common';

import { ProductFiltersPanel } from 'src/common/components/pinned-date-range-filters-panel';
import { PLATFORM_APP_ID } from 'src/common/consts/dom-consts';
import { PINNED_DATE_RANGE_MAX_VISIBLE_CHIPS } from 'src/common/consts/FilterPanelConsts';
import {
	buildPanelInitialValues,
	mapPanelValuesToFilters,
	mapToPanelDefinitions,
	stripDefaultPanelValues
} from 'src/common/helpers/FiltersPanelHelper';

import { DashboardFiltersPanelProps } from './DashboardFiltersPanel.types';

export const DashboardFiltersPanel: FC<DashboardFiltersPanelProps> = ({
	filters,
	onFilterChange,
	ariaLabel,
	skipLinkId,
	filterDefinitions,
	filterOptions,
	dataAutomationId
}) => {
	const panelDefinitions = useMemo(
		() => mapToPanelDefinitions(filterDefinitions),
		[filterDefinitions]
	);

	const initialValues = useMemo<TEvFiltersPanelValues>(
		() => buildPanelInitialValues(panelDefinitions, filters),
		[panelDefinitions, filters]
	);

	const handleApply = useCallback(
		(appliedValues: TEvFiltersPanelValues): void => {
			onFilterChange(
				mapPanelValuesToFilters(stripDefaultPanelValues(appliedValues, panelDefinitions))
			);
		},
		[onFilterChange, panelDefinitions]
	);

	const handleReset = useCallback((): void => {
		onFilterChange({});
	}, [onFilterChange]);

	return (
		<EvSection
			ariaLabel={ariaLabel}
			ariaDescribedby={TABLE_FILTERS_SR_SUMMARY}
			ariaLive="polite"
			skipLinkId={skipLinkId}
			dataAutomationId={dataAutomationId}
		>
			<ProductFiltersPanel
				appElement={PLATFORM_APP_ID}
				filterDefinitions={panelDefinitions}
				filterOptions={filterOptions ?? {}}
				initialValues={initialValues}
				onApply={handleApply}
				onReset={handleReset}
				maxVisibleChips={PINNED_DATE_RANGE_MAX_VISIBLE_CHIPS}
			/>
		</EvSection>
	);
};
